<template lang="pug">
  div
    order-processing-top(:company="company")
    order-list-filters-chip(v-if="checkFilter" :company="company")
    v-container.pa-0(style="max-width: 600px")
      div
        v-divider.basic300
        div.py-3.px-4.d-flex.align-center(v-if="!isFetching")
          bulk-order-actions(:leads="leads")
          y-pagination(v-model="page" :pageSize="fetchCount" :count="totalCount")
      v-layout.my-6.px-2.pt-2(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6.px-2.pt-2(v-if="leads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center {{ $t('no_orders_found') }}
              div.p2.basic600--text.text-center {{ $t('no_orders_adjust_filter') }}
        div(v-else)
          v-divider.basic300
          div(v-for="(lead, index) in leads" :key="lead.id")
            order-item(:parentLead.sync="lead" :menu="menu" @deleted="handleDeletedItem($event)")
            v-divider.basic300
        div.py-3.px-4
          y-pagination-custom(v-if="leads.length > 0" v-model="page" :parentPageSize.sync="fetchCount" :count="totalCount" :text="'Show orders'" data-v-step='TourOrderListView-5' )
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import queryString from 'query-string'
import OrderProcessingTop from '@/components/ordermgmt/OrderProcessingTop.vue'
import OrderListFiltersChip from '@/components/ordermgmt/OrderListFiltersChip.vue'
import OrderItem from '@/components/ordermgmt/OrderItem.vue'
import BulkOrderActions from '@/components/ordermgmt/BulkOrderActions'

export default {
  name: 'OrderListView',
  components: { OrderProcessingTop, OrderListFiltersChip, OrderItem, BulkOrderActions },
  props: ['company', 'menu'],
  data: vm => ({
    isFetching: false,
    searchCountDown: null,
    page: 1,
    fetchCount: 20,
    totalCount: vm.$store.state.ui.pendingOrderCount,
    leads: [],
    checkAll: false
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters',
      selectedLeads: 'orders/getSelectedLeads',
      search: 'orders/getSearch',
      orderTempData: 'tours/getOrderTempData'
    }),
    checkFilter() {
      if (!this.filters.sort && !this.filters.date && !this.filters.range && !this.filters.processing && !this.filters.ready && !this.filters.shipping && !this.filters.payment && !this.filters.source) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    page(val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    fetchCount() {
      this.page = 1
      this.fetchLeads(1)
    },
    search() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.fetchLeads(1)
      }, 500)
    },
    filters: {
      deep: true,
      handler() {
        this.fetchLeads(1)
      }
    },
    '$store.state.orders.leadsVersion'() {
      this.fetchLeads(1)
    }
  },
  mounted() {
    this.fullscreen = window.innerWidth < 600
    // this.fetchZones()
    if (!this.$route.query.page) {
      this.fetchLeads(1)
    } else {
      this.fetchLeads(this.$route.query.page)
    }
  },
  methods: {
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let params = new URLSearchParams()
      params.append('page', page)
      params.append('page_size', this.fetchCount)
      params.append('form__company', this.company.id)
      params.append('form_type_exclude', 'book_income')
      params.append('status', 'processed')
      if (this.search && this.search.length >= 2 && this.search.includes('#')) {
        params.append('rid', this.search.replace('#', ''))
      } else if (this.search) {
        params.append('search', this.search)
      }
      if (this.member.role !== 'Admin') {
        params.append('member', this.member.id)
      }
      if (this.filters.sort === 'oldest') {
        params.append('ordering', 'processed_at')
      } else {
        params.append('ordering', '-processed_at')
      }
      if (this.filters.date && this.filters.range) {
        if (this.filters.date === 'created') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('processed_at_after', this.filters.range.dates[0])
              params.append('processed_at_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('processed_at_after', this.filters.range.dates[0])
                params.append('processed_at_before', this.filters.range.dates[1])
              } else {
                params.append('processed_at_after', this.filters.range.dates[1])
                params.append('processed_at_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('processed_at_range', this.filters.range.value)
            }
          }
        } else if (this.filters.date === 'scheduled') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('asking_delivery_date_after', this.filters.range.dates[0])
              params.append('asking_delivery_date_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('asking_delivery_date_after', this.filters.range.dates[0])
                params.append('asking_delivery_date_before', this.filters.range.dates[1])
              } else {
                params.append('asking_delivery_date_after', this.filters.range.dates[1])
                params.append('asking_delivery_date_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('asking_delivery_date_range', this.filters.range.value)
            }
          }
        }
      }
      if (this.filters.processing || this.filters.ready) {
        let data = {
          processing: this.filters.processing || [],
          ready: this.filters.ready || []
        }
        params.append('order_management_status', JSON.stringify(data))
      }
      if (this.filters.shipping && Object.keys(this.filters.shipping).length > 0) {
        params.append('fulfilment_method', JSON.stringify(this.filters.shipping))
      }
      if (this.filters.payment && this.filters.payment.length > 0) {
        this.filters.payment.forEach(o => {
          params.append('payment_method', o.value)
        })
      }
      if (this.filters.source && this.filters.source.length > 0) {
        this.filters.source.forEach(o => {
          params.append('form', o.id)
        })
      }
      this.$axios
        .get('/leads/', { params: params })
        .then(response => {
          this.isFetching = false
          this.leads = response.data.results
          this.totalCount = response.data.count
          if (this.leads.length > 0) {
            setTimeout(() => {
              this.orderTourCheck()
            }, 2000)
          }
        })
        .catch(() => {})
    },
    fetchOneLead(leadPid) {
      // Find and update one lead
      const index = this.leads.findIndex(lead => lead.pid === leadPid)
      if (index >= 0) {
        this.$axios
          .get(`/leads/${leadPid}`)
          .then(response => {
            this.leads.splice(index, 1, response.data)
          })
          .catch(() => {})
      }
    },
    handleDeletedItem(item) {
      this.totalCount = this.totalCount - 1
      this.leads = this.leads.filter(x => x.id !== item.id)
    },
    orderTourCheck() {
      if (this.orderTempData && (this.orderTempData.value === 'completed' || (this.orderTempData.extra_data && this.orderTempData.extra_data.listView))) {
        return
      }
      this.$store.commit('tours/setOrderManagementListViewTour')
      this.$nextTick(() => {
        this.$tours['YezzaTour'].start()
      })
    }
  }
}
</script>